export default {
  IMAGE_MIN_SIZE: {
    DEFAULT: 1000,
    PRODUCT_DETAIL: 1000,
    PRODUCT_LIST: 240,
    PRODUCT_HIGHLIGHT: 500,
  },
}
